export default {
  USER_GET_VIEWERS: 'USER_GET_VIEWERS',
  USER_GET_VIEWERS_SUCCESS: 'USER_GET_VIEWERS_SUCCESS',
  USER_GET_VIEWERS_ERROR: 'USER_GET_VIEWERS_ERROR',
  USER_NEW_VIEWER: 'USER_NEW_VIEWER',
  USER_NEW_VIEWER_SUCCESS: 'USER_NEW_VIEWER_SUCCESS',
  USER_NEW_VIEWER_ERROR: 'USER_NEW_VIEWER_ERROR',
  USER_NEW_VIEWER_CLEAR: 'USER_NEW_VIEWER_CLEAR'
};



// WEBPACK FOOTER //
// ./src/constants/user/index.js